import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentRoutingUsers } from './normalize';

export const fetchShipmentRoutingUsersList = createProvider(api.fetchShipmentRoutingUsersList)
  .andThen((res) => normalizeShipmentRoutingUsers(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
